import script from "./yichang.vue?vue&type=script&setup=true&lang=js"
export * from "./yichang.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__